module.exports = __webpack_public_path__ + "img/BOR_logo.856c0147.png";